<template>
    <div class="relative">
        <a-auto-complete
            :disabled="disabled"
            :value="modelValue"
            :data-source="options"
            :placeholder="this.placeholder"
            :allowClear="this.allowClear"
            :filter-option="filterOption"
            @change="updateValue"
        />
    </div>
</template>

<script>
export default {
    props: {
        modelValue: [String, Number],
        disabled: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '',
        },
        allowClear: {
            type: Boolean,
            default: false,
        },
        options: Array,
    },
    methods: {
        filterOption(input, option) {
            return option.children()[0].toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        updateValue(value) {
            this.$emit('update:modelValue', value);
        },
    },
};
</script>
